"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarAdd = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var CalendarAdd = function CalendarAdd() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 5.053c0-1.396-1.094-2.527-2.444-2.527h-1.223V.632a.622.622 0 00-.61-.632H17.5a.622.622 0 00-.611.632v1.894H7.11V.632A.622.622 0 006.5 0H5.278a.622.622 0 00-.611.632v1.894H3.444C2.094 2.526 1 3.657 1 5.053v16.42C1 22.87 2.094 24 3.444 24h17.112C21.906 24 23 22.869 23 21.474V5.053zm-2.445 16.42H3.445V7.58h17.11v13.895zm-4.888-8.058v.96a.622.622 0 01-.611.631h-1.98v2.047a.622.622 0 01-.612.631h-.928a.622.622 0 01-.612-.631v-2.047h-1.98a.622.622 0 01-.61-.631v-.96c0-.35.273-.632.61-.632h1.98v-2.046c0-.349.274-.632.612-.632h.928c.338 0 .611.283.611.632v2.046h1.98c.338 0 .612.283.612.632z"
  });
};

exports.CalendarAdd = CalendarAdd;